import {
  GetPhotosQuery_photos_Photo,
  MetadataNameEnumType,
} from '../../__generated__/queries-photo';

export const getMetadata = (
  metadataKey: MetadataNameEnumType,
  photo: Pick<GetPhotosQuery_photos_Photo, 'photoMetadatas'> | undefined,
) => {
  return photo?.photoMetadatas?.find(
    ({ metadata }) => metadata.name === metadataKey,
  )?.value;
};
